import React from 'react';
import firebase from '../../firebase/firebase.utils';
import './test.style.scss';
import Materijal from '../materijal/materijal1.component';
import WithSpiner from '../../with-spiner/with-spiner.component';


class TestFUMIGACIJAiDDD extends React.Component{
  constructor(props){
    super(props);
    this.state={
      testFUMIGACIJAiDDD:[],
    };
  };


componentDidMount(){
  const test1Ref=firebase.database().ref('testFUMIGACIJAiDDD');
  test1Ref.on('value',(snapshot)=>{
    let testFUMIGACIJAiDDD=snapshot.val();
    let newState=[];
    for (let testUrl  in testFUMIGACIJAiDDD){
      newState.push({
        id:testUrl,
        testUrl:testFUMIGACIJAiDDD[testUrl].testUrl,
        name:testFUMIGACIJAiDDD[testUrl].name
      });
    }
    this.setState({
      testFUMIGACIJAiDDD:newState
    });
  });
  setTimeout(() => { 
    this.setState({loading: true})
  },1200)
}
render(){
  return(
<div className='test-component-container'> 
{ this.state.loading ? (   <div>
<Materijal/>

<h3>ИЗАБЕРИ СВОЈ ТЕСТ</h3>
<div className='test-component'>
{
  this.state.testFUMIGACIJAiDDD.map((testUrl)=>{
    return(
      

        <a key={testUrl.testUrl} className='test-section' href={testUrl.testUrl} alt='link'>
        <span className='test' > {testUrl.name}</span>
   </a>
   
    );
  })
}</div>
</div>): (
  <WithSpiner />
   )}
</div>
  );
}

}

export default TestFUMIGACIJAiDDD;